import { Bot } from "lucide-react";

const DEFAULT_ASSISTANT_AVATAR_SIZE_PX = 40;

interface IAssistantAvatarProps {
  assistantUuid: string;
  assistantAvatar: string | null;
  sizePx?: number;
}

export const AssistantAvatar = ({
  assistantUuid,
  assistantAvatar,
  sizePx = DEFAULT_ASSISTANT_AVATAR_SIZE_PX,
}: IAssistantAvatarProps): React.ReactElement => {
  const iconSizePx = Math.round(sizePx * 0.6);
  const paddingPx = Math.round(sizePx * 0.2);

  return assistantAvatar ? (
    <img
      src={assistantAvatar}
      alt="Assistant Avatar"
      className="shrink-0 rounded-md object-cover"
      style={{ width: sizePx, height: sizePx }}
      data-testid={`assistant-item-avatar-image-${assistantUuid}`}
    />
  ) : (
    <div
      className="flex shrink-0 items-center justify-center rounded-md bg-icon-background"
      style={{ width: sizePx, height: sizePx, padding: paddingPx }}
      data-testid={`assistant-item-avatar-fallback-${assistantUuid}`}
    >
      <Bot
        // NOTE: NSAI-6259 — the fallback tile is `bg-icon-background`, which
        // is `var(--primary) / 0` in both themes: the tile paints nothing, so
        // a `text-primary` glyph was a bare purple mark beside neutral text.
        className="text-foreground"
        style={{ width: iconSizePx, height: iconSizePx }}
      />
    </div>
  );
};
